<!--
 * @Description:修改人员信息
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <BaseDialog
    width="450px"
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="修改人员信息"
  >
    <div style="padding: 20px">
      <BaseForm
        ref="formRef"
        :model="formData"
        label-width="auto"
        label-position="right"
      >
        <BaseFormItem
          label="姓名："
          prop="name"
          :rules="[{ required: true, message: '姓名必填' }]"
        >
          <BaseInput
            style="width: 100%"
            placeholder="请输入姓名"
            v-model="formData.name"
            maxlength="30"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem
          label="手机号："
          prop="phone"
          :rules="[
            {
              required: true,
              trigger: 'blur',
              validator: validatorPhone
            }
          ]"
        >
          <BaseInput
            style="width: 100%"
            placeholder="请输入手机号"
            v-model="formData.phone"
            type="tel"
            maxlength="11"
          ></BaseInput>
        </BaseFormItem>
        <p>注：修改后所有该人员参与的项目将全部修改，请谨慎操作</p>
      </BaseForm>
    </div>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onSave" type="primary">确定</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { reactive, ref } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseButton,
  XrkMessageBox
} from 'xrk-components';
import { modifyProjectPeopleUserName } from '../data-source/apis';
import { validatorPhone } from '@/utils/validator';

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    row: any;
  }>(),
  {
    remove() {
      return () => ({});
    },
    row: () => ({})
  }
);
const emits = defineEmits(['success']);
const formRef = ref<BaseFormRef>(null);
const formData = reactive<{
  name: string;
  phone: number;
}>({
  name: props.row.name,
  phone: null
});
const onSave = async () => {
  await formRef.value.validate();
  await XrkMessageBox.confirm(
    '修改后所有该人员参与的项目将全部修改，请谨慎操作',
    '请确认是否修改'
  );
  await modifyProjectPeopleUserName({
    projectId: props.row.projectId,
    userId: props.row.userId,
    userName: formData.name,
    phone: formData.phone
  });
  emits('success');
  onCancel();
};
const onCancel = () => {
  props.remove();
};
</script>
